<template>
  <div id="app" class="">
      <transition name="slide-fade" mode="out-in" appear>
              <router-view class="routerbox"  ></router-view>
      </transition>
  </div>
</template>


<script>
export default {
  name: 'App',
  components: {
  },
  data () {
    return {
    } 
  },
  mounted () {
    !function(n){
        var  e=n.document,
             t=e.documentElement,
             i=750,
             d=i/100,
             o="orientationchange"in n?"orientationchange":"resize",
             a=function(){
                 var n=t.clientWidth||320;n>750&&(n=750);
                 t.style.fontSize=n/d+"px"
             };
             e.addEventListener&&(n.addEventListener(o,a,!1),e.addEventListener("DOMContentLoaded",a,!1))
    }(window);
  },
  methods:{
  }
}
</script>

<style>
*{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;margin:0;padding:0;-webkit-tap-highlight-color:rgba(0,0,0,0)}html{font-size:100%;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%}body,html{min-height:100%}body{position:relative;width:100%;font-size:14px;font-family:Microsoft YaHei,微软雅黑,MicrosoftJhengHei,华文细黑,Helvetica,Arial,"sans-serif";word-break:break-all}a{-webkit-box-sizing:border-box;text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,0.35)}img{vertical-align:middle;-ms-interpolation-mode:bicubic}img:not([src*="/"]){display:none}table{border-collapse:collapse;border-spacing:0}caption,td,th{vertical-align:middle}textarea{resize:none}button,input,select,textarea{outline:0;border-radius:0;-webkit-appearance:none}input::-webkit-inner-spin-button,input::-webkit-outer-spin-button{margin:0;-webkit-appearance:none!important}li,ol,ul{list-style:none;-webkit-margin-before:0;-webkit-margin-after:0;-webkit-margin-start:0;-webkit-margin-end:0;-webkit-padding-start:0; }
body{ overflow: hidden; }
.wrap{margin:0 auto;/* max-width:7.5rem; */ width: 100%; background:#fefefe; margin:0 auto; height: 100vh; position:relative;}



   .loadingTopbox{width: 100%;
   height: 100vh;
   background-color: rgba(0,0,0,0.9);
   z-index: 999;
   display: flex;
   justify-content: center;
   align-items: center;
   color: #d6d6d6; } 

   .topbox{width: 100%;
   height: 100vh; top:0rem;
   background-color: rgba(0,0,0,0.9);
   position: fixed; 
   z-index: 999;
   display: flex;
   justify-content: center;
   align-items: center;
   color: #d6d6d6; } 

    svg.closeBtnBj{ top:-0.1rem; right: -0.1rem;  width: 1.5rem; height: 1.5rem;    transform: rotate(180deg);    -webkit-transform: rotate(180deg);}
   svg.closeBtn{ top:0.12rem; right: 0.12rem; width: 0.5rem;  height: 0.5rem;}
   .closeBtns svg.icon{ position: fixed; }
   .closeBtns{ z-index: 99999 }

</style>



// WEBPACK FOOTER //
// src/App.vue